import React from 'react';
import { useSelector } from 'react-redux';
import { globalSessionENums, Images } from 'utils';

export const SessionWarning = ({ apptId }) => {
    const { therapySession } = useSelector((state) => ({
        therapySession: state.auth.therapySessionEvents?.[globalSessionENums.SESSION_EXPIRED],
    }));
    const expiredApptSessions = therapySession?.evenType === globalSessionENums.SESSION_EXPIRED && therapySession?.data;
    const currentSession = expiredApptSessions && expiredApptSessions?.find((i) => i?.apptId === apptId);

    if (!currentSession) {
        return null;
    }

    return (
        <div className="session-warning" style={{ padding: '8px 16px', height: 'auto' }}>
            <div className="flex-align-center" style={{ gap: 12 }}>
                <img src={Images.alertWarning} alt="warning" style={{ width: 20 }} />
                <div style={{ textAlign: 'start' }}>
                    <p className="session-warning-title"> The scheduled end time for this appointments has passed.</p>
                </div>
            </div>
        </div>
    );
};
